import { Link } from '@kl/components-v6';
import React, { ReactNode } from 'react';

const separator = '@#$@';
const tagRegexp = /^<a([^>]*)>(.*?)<\/a>$/;
const attrRegexp = /[\w-]+=(['][^']+[']|["][^"]+["])/g;
const stringRegexp = /<a[^>]+>[^<]*<\/a>/g;

interface Args {
    localizedString: string;
    additionalAttributes?: Record<string, Record<string, any>>;
    color?: string;
}

export const replaceLink = ({
    localizedString,
    additionalAttributes,
    color,
}: Args): ReactNode[] => {
    const replace = (tag: string) => {
        const tagParts = tag.match(tagRegexp);

        if (!tagParts) return tag;

        const [_, openTagWithAttributes, text] = tagParts;
        const attributesInStringPresent = openTagWithAttributes.match(attrRegexp);

        if (!attributesInStringPresent) return tag;

        const attributes = attributesInStringPresent.reduce<Record<string, any>>(
            (acc, attributeWithValue) => {
                const [key, ...value] = attributeWithValue.split('=');
                acc[key] = value.join('=').replace(/^'/, '').replace(/'$/, '');

                return acc;
            },
            {},
        );

        const id = attributes['id'] as string;

        if (id && additionalAttributes?.[id]) {
            return (
                <Link
                    {...attributes}
                    {...additionalAttributes[id]}
                    style={{ ...(color && { color }) }}
                >
                    {text}
                </Link>
            );
        }

        return <Link {...attributes}>{text}</Link>;
    };

    const link = localizedString
        .replace(stringRegexp, match => separator + match + separator)
        .split(separator)
        .filter(Boolean)
        .map(replace);

    return link;
};
